import { NOT_FOUND } from '@mm/constants/status-codes';
import { Dispatch } from 'redux';
import CompanyController from '../controllers/CompanyController';
import commonHandler from '../errorHandlers/common-handler';
import CompanyModel from '../model/CompanyModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class CompanyCRUDActions extends CrudActionContainer {
  constructor() {
    super('COMPANY');
  }

  create(entity: Partial<CompanyModel> & { instachamp?: boolean }) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));
      try {
        const response = await CompanyController.postCompany(entity);
        await dispatch(this.retrieveAll());
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  retrieveAll() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await CompanyController.getAll();
        dispatch(this.retrievedAll(response));

        return response;
      } catch (error) {
        await commonHandler(dispatch)(error);
      }
    };
  }

  getByCompany(entity: Partial<CompanyModel>) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await CompanyController.getById(entity);
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        if (error instanceof Response) {
          if (error.status === NOT_FOUND) {
            return;
          }
        }
        commonHandler(dispatch)(error);
      }
    };
  }

  getById(id: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      return dispatch(companyCRUDActions.getByCompany({ id }));
    };
  }

  update(entity: Partial<CompanyModel>) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));

      try {
        const response = await CompanyController.update(entity);

        // This seems wrong. Not sure if we meant to type 'this.retrievedAll'
        // or accidentally are passing a unneeded param.
        //
        // @ts-ignore
        dispatch(this.retrieveAll(response));
        return response;
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  }

  retrieveCompanyBots(companyId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        if (companyId) {
          const response = await CompanyController.getCompanyBots(companyId);
          dispatch(this.retrieved(response));

          return response;
        }
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  }
}

const companyCRUDActions = new CompanyCRUDActions();

export default companyCRUDActions;

export const useCompanyCRUDActions = getActionHookBuilder(companyCRUDActions, [
  'retrieveAll',
  'update',
  'getById',
  'create',
]);
